// ======================================================================
// File Name       : GroupTree
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import TreeView from '../Tree';
import { createTree } from '../../utils/groupUtils';

class GroupTree extends React.Component {

  /**
     * Function for building tree
     */
  buildTree() {
    const { selectedGroup, groupList, isCheckBox } = this.props;
    const isDisabled = true;
    let selectedGroupCheck = selectedGroup;
    if (isCheckBox && selectedGroup) {
      selectedGroupCheck = selectedGroup.reduce((ids, cur) => {
        ids.push(cur.groupSecernId);
        return ids;
      }, []);
    }
    return createTree(groupList, isCheckBox, selectedGroupCheck, isDisabled);
  }

  /**
     * [convertJsonToDataTree convert json to data tree]
     * @param  {array} groupList [group list]
     * @return {array} dataTree  [data tree]
     */

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate = nextProps.groupList === this.props.groupList;
    return !shouldNotUpdate;
  }

  /**
   * Render GUI
   * @returns {XML}
   */
  render() {
    const nodes = this.buildTree();
    const { isCheckBox } = this.props;

    return (
      <TreeView
        id="groupTree"
        data={nodes}
        isNotRefresh
        onSelectNode={(e, data) => {
          if (isCheckBox) return;
          this.props.handleSelectNode(e, data);
        }}
        ref={(instance) => {
          this.treeInstance = instance;
        }}
        onSelectCheckbox={(e, node) => {
          if (!isCheckBox) {
            return;
          }
          let selectedGroupIds = [];
          if (node && node.selected) {
            selectedGroupIds = node.selected;
          }
          this.props.handleSelectCheckBox(e, selectedGroupIds);
        }}
        checkbox={isCheckBox}
      />
    );
  }
}

export default GroupTree;
